import { useApiQuery } from 'theSource/utils';
import { UnumIndexResponseDto } from './types/dtos';
import { GET_UNUM_INDEX_KEY } from './utils';

export interface UseUnumIndexQueryProps {
  enabled: boolean;
  lumosApiHost: string;
  enrollmentContext: string;
  orgBenefitId: number;
}

export const useUnumIndexQuery = ({
  enabled,
  lumosApiHost,
  enrollmentContext,
  orgBenefitId,
}: UseUnumIndexQueryProps) => {
  const { data, isLoading, isFetching } = useApiQuery<UnumIndexResponseDto>({
    queryKey: `${GET_UNUM_INDEX_KEY}-${enrollmentContext}-${orgBenefitId}`,
    config: {
      baseURL: `${lumosApiHost}/v2/self_service`,
    },
    endpoint: `/plugins/unum/index/${orgBenefitId}`,
    enabled: enabled,
    params: {
      enroll_type: enrollmentContext,
    },
  });

  return {
    data,
    isLoading,
    isFetching,
  };
};
